import type { VAxios } from '../../define/axios/Axios';

/**
 * 文件上传接口 STS 配置
 */
export const createApi = (defHttp: VAxios) => ({
  //#region 文件上传接口
  getUploadSTS: (type: string) => {
    return defHttp.get({ url: '/aiad/upload', params: { type } });
  },
  //#endregion
});
